import { useState, useEffect } from 'react';
import { BackgroundSwitcher } from '../backgrounds';

/**
 * AppLayout - Layout global de la aplicación
 *
 * Estructura de capas:
 * - Capa 0: Background dinámico (BackgroundSwitcher)
 * - Capa 1+: Contenido de la página (children)
 *
 * El background activo se lee de localStorage y se actualiza
 * escuchando el custom event 'raios_background_change' que dispara
 * AppearanceSection cuando el usuario selecciona un fondo.
 */
export function AppLayout({ children, show_controls = false }) {
  const [active_background, set_active_background] = useState(() => {
    return localStorage.getItem('raios_background') || 'magnetic_field';
  });

  useEffect(() => {
    const handle_change = (e) => set_active_background(e.detail);
    window.addEventListener('raios_background_change', handle_change);
    return () => window.removeEventListener('raios_background_change', handle_change);
  }, []);

  return (
    <>
      {/* Background dinámico - Capa 0 */}
      <div className="fixed inset-0 z-0">
        <BackgroundSwitcher
          show_controls={show_controls}
          active_background={active_background}
        />
      </div>

      {/* Contenido de la página */}
      {children}
    </>
  );
}

export default AppLayout;
